import { SxProps } from '@mui/material';
import { theme } from '@portals/core/src/themes/immobilien/main';

export const styles: Record<string, SxProps> = {
  showMoreResultsContainer: {
    p: 5,
    pt: 4,
  },
  showMoreResultsButton: {
    maxWidth: { lg: '704px' },
    m: 'auto',
  },
  secondaryButton: {
    boxShadow: `${theme.palette.grey[400]} 0px 0px 0px 1px inset`,
    '&.MuiButtonBase-root': {
      px: 6,
    },
  },
};
